import { useState } from 'react';
import { supabase } from '../supabaseClient';
import './AddModal.css';

function AddProfileModal({ closeModal, onDataAdded }) {
  const [nomePerfil, setNomePerfil] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    // Usando a função segura que criamos no Supabase
    const { error: rpcError } = await supabase
      .rpc('create_profile', {
        profile_name_to_insert: nomePerfil
      });
      
    if (rpcError) {
      console.error("Erro RPC:", rpcError);
      setError(rpcError.message);
    } else {
      onDataAdded();
      closeModal();
    }
    setLoading(false);
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-content">
        <h2>Adicionar Novo Perfil de Navegador</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nome do Perfil</label>
            <input type="text" placeholder="Ex: Chrome, Edge, Firefox" value={nomePerfil} onChange={(e) => setNomePerfil(e.target.value)} required />
          </div>
          {error && <p className="error-message">{error}</p>}
          <div className="modal-actions">
            <button type="button" onClick={closeModal} className="button-cancel">Cancelar</button>
            <button type="submit" className="button-save" disabled={loading}>{loading ? 'Salvando...' : 'Salvar Perfil'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddProfileModal;